var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnfettiDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 696,
    viewBox: "0 0 1920 696",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 696
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 696,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.747 162.495C579.979 162.495 578.002 160.319 578.002 157.747C578.002 154.978 580.177 153 582.747 153C585.514 153 587.491 155.176 587.491 157.747C587.689 160.319 585.514 162.495 582.747 162.495Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.862 159.317C627.303 159.317 624.337 156.35 624.337 152.789C624.337 149.229 627.303 146.262 630.862 146.262C634.42 146.262 637.386 149.229 637.386 152.789C637.188 156.35 634.42 159.317 630.862 159.317Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.396 120.547C548.616 120.547 547.232 119.162 547.232 117.382C547.232 115.601 548.616 114.217 550.396 114.217C552.175 114.217 553.559 115.601 553.559 117.382C553.559 119.162 552.175 120.547 550.396 120.547Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.756 237.517C602.779 237.517 601 235.934 601 233.758C601 231.78 602.582 230 604.756 230C606.733 230 608.513 231.582 608.513 233.758C608.315 235.934 606.733 237.517 604.756 237.517Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.756 542.517C378.779 542.517 377 540.934 377 538.758C377 536.78 378.582 535 380.756 535C382.733 535 384.513 536.582 384.513 538.758C384.315 540.934 382.733 542.517 380.756 542.517Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.755 272.517C540.778 272.517 538.999 270.934 538.999 268.758C538.999 266.78 540.581 265 542.755 265C544.732 265 546.512 266.582 546.512 268.758C546.314 270.934 544.732 272.517 542.755 272.517Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 560.846L74 567L66.9035 543L53 560.846Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 369.154L147 373L142.269 358L133 369.154Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 139.537L134.019 156L138 129L115 139.537Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99962 259.495L19.0019 274.33L22.5605 250L1.99962 259.495Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 64.2577L60 76L56.4706 47L36 64.2577Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 278.89L140.409 291.154L141.991 269L124 278.89Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.001 223.89L174.411 236.154L175.992 214L158.001 223.89Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 617.018L126.385 622L127 613L120 617.018Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.499 42.2056L219.653 52.4915L216.49 26.9746L198.499 42.2056Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 117.892L54.0563 131L59 112L41 117.892Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 469.823L100.507 485L106 463L86 469.823Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 341.032L566.331 350L571 337L554 341.032Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 333.513L451.507 348L457 327L437 333.513Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5023 89C15.0967 89 18 91.9043 18 95.5C18 99.0957 15.0967 102 11.5023 102C7.90779 102 5.00454 99.0957 5.00454 95.5C4.86629 91.9043 7.90779 89 11.5023 89Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5023 424C43.0967 424 46 426.904 46 430.5C46 434.096 43.0967 437 39.5023 437C35.9078 437 33.0045 434.096 33.0045 430.5C32.8663 426.904 35.9078 424 39.5023 424Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.294 8C168.434 8 172.586 12.1539 172.586 17.2969C172.586 22.4399 168.434 26.5939 163.294 26.5939C158.154 26.5939 154.002 22.4399 154.002 17.2969C154.002 12.1539 158.154 8 163.294 8Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.98 9.96289C314.55 9.96289 316.725 12.1388 316.725 14.7104C316.725 17.2819 314.55 19.4578 311.98 19.4578C309.41 19.4578 307.235 17.2819 307.235 14.7104C307.235 11.941 309.212 9.96289 311.98 9.96289Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.779 13.5215C452.349 13.5215 454.523 15.6974 454.523 18.2689C454.523 20.8404 452.349 23.0162 449.779 23.0162C447.208 23.0162 445.034 20.8404 445.034 18.2689C445.034 15.6974 447.208 13.5215 449.779 13.5215Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.96 161.68C161.926 161.68 164.496 164.053 164.496 167.218C164.496 170.185 162.124 172.757 158.96 172.757C155.995 172.757 153.425 170.383 153.425 167.218C153.622 164.053 155.995 161.68 158.96 161.68Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7983 257.914C56.7638 257.914 59.334 260.288 59.334 263.453C59.334 266.42 56.9615 268.991 53.7983 268.991C50.8327 268.991 48.2626 266.618 48.2626 263.453C48.4603 260.288 50.8327 257.914 53.7983 257.914Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.535 391C504.5 391 507.07 393.374 507.07 396.539C507.07 399.506 504.698 402.077 501.535 402.077C498.569 402.077 495.999 399.703 495.999 396.539C496.197 393.374 498.569 391 501.535 391Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5418 72.8652C93.1234 72.8652 94.5073 74.2498 94.5073 75.8321C94.5073 77.4144 93.1234 78.7989 91.5418 78.7989C89.9602 78.7989 88.5763 77.4144 88.5763 75.8321C88.3786 74.2498 89.7625 72.8652 91.5418 72.8652Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3498 4C29.7222 4 31.6992 5.97803 31.6992 8.35172C31.6992 10.7254 29.7222 12.7035 27.3498 12.7035C24.9774 12.7035 23.0004 10.7254 23.0004 8.35172C23.0004 5.97803 24.9774 4 27.3498 4Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 184.428C45.6768 184.428 47.8516 186.801 47.8516 189.571C47.8516 192.538 45.4791 194.714 42.7113 194.714C39.7458 194.714 37.5711 192.34 37.5711 189.571C37.3734 186.604 39.7458 184.428 42.7113 184.428Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.152 353C236.117 353 238.292 355.374 238.292 358.143C238.292 361.11 235.92 363.286 233.152 363.286C230.186 363.286 228.012 360.912 228.012 358.143C227.814 355.176 230.186 353 233.152 353Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.767 83C171.349 83 172.535 84.1868 172.535 85.7693C172.535 87.3518 171.349 88.5386 169.767 88.5386C168.186 88.5386 167 87.3518 167 85.7693C167.197 84.1868 168.383 83 169.767 83Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.071 3.83008C116.85 3.83008 118.234 5.21465 118.234 6.99487C118.234 8.7751 116.85 10.1597 115.071 10.1597C113.291 10.1597 111.907 8.7751 111.907 6.99487C111.907 5.21465 113.291 3.83008 115.071 3.83008Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.197 161.68C191.778 161.68 193.162 163.064 193.162 164.647C193.162 166.229 191.778 167.614 190.197 167.614C188.615 167.614 187.231 166.229 187.231 164.647C187.231 163.064 188.615 161.68 190.197 161.68Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.966 222C110.547 222 111.931 223.385 111.931 224.967C111.931 226.55 110.547 227.934 108.966 227.934C107.384 227.934 106 226.55 106 224.967C106 223.385 107.384 222 108.966 222Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9641 686C97.5458 686 98.9297 687.385 98.9297 688.967C98.9297 690.55 97.5458 691.934 95.9641 691.934C94.3825 691.934 92.9986 690.55 92.9986 688.967C92.9986 687.385 94.3825 686 95.9641 686Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.966 478C508.547 478 509.931 479.385 509.931 480.967C509.931 482.55 508.547 483.934 506.966 483.934C505.384 483.934 504 482.55 504 480.967C504 479.385 505.384 478 506.966 478Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.112 112.031C182.287 112.031 184.066 113.812 184.066 115.987C184.066 118.163 182.287 119.944 180.112 119.944C177.937 119.944 176.158 118.163 176.158 115.987C176.158 113.812 177.937 112.031 180.112 112.031Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.952 433C386.127 433 387.906 434.78 387.906 436.956C387.906 439.132 386.127 440.912 383.952 440.912C381.777 440.912 379.998 439.132 379.998 436.956C379.998 434.78 381.777 433 383.952 433Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.952 481C205.127 481 206.906 482.78 206.906 484.956C206.906 487.132 205.127 488.912 202.952 488.912C200.777 488.912 198.998 487.132 198.998 484.956C198.998 482.78 200.777 481 202.952 481Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.707 106.492C114.277 106.492 116.452 108.668 116.452 111.24C116.452 113.811 114.277 115.987 111.707 115.987C109.137 115.987 106.962 113.811 106.962 111.24C107.16 108.47 109.137 106.492 111.707 106.492Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 17C258.2 17 260 18.8 260 21C260 23.2 258.2 25 256 25C253.8 25 252 23.2 252 21C252 18.8 254 17 256 17Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.546 13C509.71 13 512.082 15.5715 512.082 18.5387C512.082 21.7036 509.512 24.0773 506.546 24.0773C503.383 24.0773 501.011 21.5058 501.011 18.5387C500.813 15.5715 503.383 13 506.546 13Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498 140L503 121L483 127.421L498 140Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.499 240.424L387.327 223.412L363.01 219.852L372.499 240.424Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.282 134L309 114L285 116.941L299.282 134Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.877 407L305 386L280 389.088L294.877 407Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.773 331.762L32 339.859L56.351 361.342L60.773 331.762Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.013 190L457 173.317L431 167L439.013 190Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804 59.7812L790.243 46L786 67L804 59.7812Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 199.844L531.771 190L528 205L544 199.844Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 161.497C332 157.35 335.351 154 339.5 154C343.649 154 347 157.35 347 161.497C347 165.645 343.649 168.995 339.5 168.995C335.351 169.154 332 165.804 332 161.497Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.998 305.297C256.998 300.154 261.15 296 266.29 296C271.43 296 275.582 300.154 275.582 305.297C275.582 310.44 271.43 314.594 266.29 314.594C261.15 314.792 256.998 310.638 256.998 305.297Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 288.297C360 283.154 364.152 279 369.292 279C374.432 279 378.584 283.154 378.584 288.297C378.584 293.44 374.432 297.594 369.292 297.594C364.152 297.792 360 293.638 360 288.297Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.609 25.5899C739.609 20.4469 743.761 16.293 748.901 16.293C754.042 16.293 758.193 20.4469 758.193 25.5899C758.193 30.7328 754.042 34.8867 748.901 34.8867C743.761 35.0845 739.609 30.7328 739.609 25.5899Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.999 44.5387C900.999 41.5716 903.371 39 906.535 39C909.5 39 912.07 41.3737 912.07 44.5387C912.07 47.5058 909.698 50.0773 906.535 50.0773C903.371 50.0773 900.999 47.5058 900.999 44.5387Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.898 96.6604C428.898 95.078 430.281 93.6934 431.863 93.6934C433.445 93.6934 434.829 95.078 434.829 96.6604C434.829 98.2428 433.445 99.6274 431.863 99.6274C430.281 99.6274 428.898 98.2428 428.898 96.6604Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.999 150.747C384.999 147.978 387.173 146 389.743 146C392.511 146 394.488 148.176 394.488 150.747C394.488 153.517 392.314 155.495 389.743 155.495C387.173 155.693 384.999 153.517 384.999 150.747Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.322 227.572C216.322 224.802 218.497 222.824 221.067 222.824C223.835 222.824 225.812 225 225.812 227.572C225.812 230.341 223.637 232.319 221.067 232.319C218.497 232.517 216.322 230.341 216.322 227.572Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.999 607.747C216.999 604.978 219.173 603 221.743 603C224.511 603 226.488 605.176 226.488 607.747C226.488 610.517 224.314 612.495 221.743 612.495C219.173 612.693 216.999 610.517 216.999 607.747Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 60.3518C372 57.9781 373.977 56 376.349 56C378.722 56 380.699 57.9781 380.699 60.3518C380.699 62.7255 378.722 64.7036 376.349 64.7036C373.977 64.7036 372 62.7255 372 60.3518Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 211.352C295 208.978 296.977 207 299.35 207C301.722 207 303.699 208.978 303.699 211.352C303.699 213.725 301.722 215.704 299.35 215.704C296.977 215.704 295 213.725 295 211.352Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 499.352C266 496.978 267.977 495 270.349 495C272.722 495 274.699 496.978 274.699 499.352C274.699 501.725 272.722 503.704 270.349 503.704C267.977 503.704 266 501.725 266 499.352Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.306 32.3142C817.306 30.7317 818.492 29.5449 820.074 29.5449C821.656 29.5449 822.842 30.7317 822.842 32.3142C822.842 33.8966 821.656 35.0834 820.074 35.0834C818.492 35.0834 817.306 33.6988 817.306 32.3142Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.001 52.1541C654.001 49.9782 655.781 48 658.153 48C660.328 48 662.305 49.7804 662.305 52.1541C662.305 54.3301 660.525 56.3083 658.153 56.3083C655.978 56.3083 654.001 54.5279 654.001 52.1541Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 133.528C230 129.967 232.966 127 236.524 127C240.083 127 243.048 129.967 243.048 133.528C243.048 137.088 240.083 140.055 236.524 140.055C232.966 139.857 230 137.088 230 133.528Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 56.1649C423 54.3847 424.384 53 426.163 53C427.943 53 429.327 54.3847 429.327 56.1649C429.327 57.9452 427.943 59.3299 426.163 59.3299C424.384 59.3299 423 57.9452 423 56.1649Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 74.7582C316 72.7802 317.582 71 319.756 71C321.733 71 323.513 72.5824 323.513 74.7582C323.513 76.7363 321.931 78.5165 319.756 78.5165C317.582 78.3187 316 76.7363 316 74.7582Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.999 252.758C456.999 250.78 458.581 249 460.755 249C462.732 249 464.512 250.582 464.512 252.758C464.512 254.736 462.93 256.516 460.755 256.516C458.581 256.319 456.999 254.736 456.999 252.758Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 179.758C260 177.78 261.582 176 263.756 176C265.733 176 267.513 177.582 267.513 179.758C267.513 181.736 265.931 183.516 263.756 183.516C261.582 183.319 260 181.736 260 179.758Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.999 333.758C327.999 331.78 329.581 330 331.755 330C333.732 330 335.512 331.582 335.512 333.758C335.512 335.736 333.93 337.516 331.755 337.516C329.581 337.319 327.999 335.736 327.999 333.758Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323 83.5385C1323 80.5715 1325.37 78 1328.54 78C1331.5 78 1334.07 80.3736 1334.07 83.5385C1334.07 86.5056 1331.7 89.0771 1328.54 89.0771C1325.37 89.0771 1323 86.5056 1323 83.5385Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531 240.539C1531 237.571 1533.37 235 1536.53 235C1539.5 235 1542.07 237.374 1542.07 240.539C1542.07 243.506 1539.7 246.077 1536.53 246.077C1533.37 246.077 1531 243.506 1531 240.539Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.999 24.9671C980.999 23.3846 982.383 22 983.964 22C985.546 22 986.93 23.3846 986.93 24.9671C986.93 26.5495 985.546 27.9341 983.964 27.9341C982.383 27.9341 980.999 26.5495 980.999 24.9671Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.998 18.9562C865.998 16.7803 867.777 15 869.952 15C872.127 15 873.906 16.7803 873.906 18.9562C873.906 21.1321 872.127 22.9124 869.952 22.9124C867.777 22.7145 865.998 20.9343 865.998 18.9562Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.508 76.2866C462.508 73.715 464.683 71.5391 467.253 71.5391C469.823 71.5391 471.998 73.715 471.998 76.2866C471.998 78.8581 469.823 81.0341 467.253 81.0341C464.485 80.8362 462.508 78.8581 462.508 76.2866Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 111.998C382 108.68 384.681 106 388 106C391.319 106 394 108.68 394 111.998C394 115.316 391.319 117.996 388 117.996C384.681 118.123 382 115.316 382 111.998Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.431 80.1594L272.385 65.5215L256.766 70.4667L268.431 80.1594Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.138 67.1515L604.092 52.5137L588.473 57.4589L600.138 67.1515Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.727 90.6624L541.449 77.0137L525.04 78.9917L534.727 90.6624Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.236 29.5446C634.236 26.5774 636.609 24.0059 639.772 24.0059C642.737 24.0059 645.308 26.3796 645.308 29.5446C645.308 32.5117 642.935 35.0832 639.772 35.0832C636.609 35.0832 634.236 32.5117 634.236 29.5446Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.383 32.3142C535.383 30.7317 536.569 29.5449 538.151 29.5449C539.733 29.5449 540.919 30.7317 540.919 32.3142C540.919 33.8966 539.733 35.0834 538.151 35.0834C536.569 35.0834 535.383 33.6988 535.383 32.3142Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.001 12.5825C702.001 11.5934 702.791 11 703.582 11C704.571 11 705.164 11.7912 705.164 12.5825C705.164 13.5715 704.373 14.1649 703.582 14.1649C702.791 14.3627 702.001 13.5715 702.001 12.5825Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.999 249.967C298.999 248.385 300.383 247 301.964 247C303.546 247 304.93 248.385 304.93 249.967C304.93 251.55 303.546 252.934 301.964 252.934C300.383 252.934 298.999 251.55 298.999 249.967Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.492 307.287C184.492 305.705 185.876 304.32 187.457 304.32C189.039 304.32 190.423 305.705 190.423 307.287C190.423 308.87 189.039 310.254 187.457 310.254C185.876 310.254 184.492 308.87 184.492 307.287Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.999 423.967C199.999 422.385 201.382 421 202.964 421C204.546 421 205.93 422.385 205.93 423.967C205.93 425.549 204.546 426.934 202.964 426.934C201.382 426.934 199.999 425.549 199.999 423.967Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 557.967C174 556.385 175.384 555 176.966 555C178.547 555 179.931 556.385 179.931 557.967C179.931 559.549 178.547 560.934 176.966 560.934C175.384 560.934 174 559.549 174 557.967Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7508 304.104C89.5678 305.155 87.614 305.039 86.564 303.855C85.514 302.672 85.6303 300.718 86.8133 299.667C87.9962 298.616 89.9501 298.733 91.0001 299.916C92.0501 301.099 91.9337 303.054 90.7508 304.104Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.43 26.0381C371.43 23.8623 373.209 22.082 375.384 22.082C377.559 22.082 379.338 23.8623 379.338 26.0381C379.338 28.214 377.559 29.9943 375.384 29.9943C373.209 29.9943 371.43 28.214 371.43 26.0381Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.999 56.9671C704.999 55.3846 706.383 54 707.964 54C709.546 54 710.93 55.3846 710.93 56.9671C710.93 58.5495 709.546 59.9341 707.964 59.9341C706.383 59.9341 704.999 58.5495 704.999 56.9671Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.613 8.57727C584.613 6.40137 586.393 4.62109 588.567 4.62109C590.742 4.62109 592.521 6.40137 592.521 8.57727C592.521 10.7532 590.742 12.5334 588.567 12.5334C586.393 12.3356 584.613 10.5554 584.613 8.57727Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.128 40.0007L121 42.3535L133.749 75.5132L139.877 73.1604L127.128 40.0007Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.584 406.732L149.184 403L129 432.236L134.4 435.968L154.584 406.732Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.887 272.999L485 278.895L516.913 294.504L519.8 288.609L487.887 272.999Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.42 359.488L1787.86 356L1769 386.104L1774.56 389.593L1793.42 359.488Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.92 56.8794L1779.67 58.877L1790.5 92.7131L1796.75 90.7156L1785.92 56.8794Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1516.25 280.001L1510 281.998L1520.83 315.834L1527.08 313.837L1516.25 280.001Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.7 127.485L1489.7 142.32L1493.26 117.99L1472.7 127.485Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666 345.495L1683 360.33L1686.56 336L1666 345.495Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 213.89L1431.41 226.155L1432.99 204L1415 213.89Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 412.89L1836.41 425.155L1837.99 403L1820 412.89Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738 519.589L1750.77 529L1752 512L1738 519.589Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 253.89L1661.41 266.155L1662.99 244L1645 253.89Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184 38.3411L1200 46L1197.61 27L1184 38.3411Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.67 74.0773L1427.03 95.6382L1434.74 64.3848L1406.67 74.0773Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 8C1153.87 8 1157 11.1276 1157 15C1157 18.8723 1153.87 22 1150 22C1146.13 22 1143 18.8723 1143 15C1143 11.1276 1146.13 8 1150 8Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.5 61C1060.44 61 1062 62.5638 1062 64.5C1062 66.4362 1060.44 68 1058.5 68C1056.56 68 1055 66.4362 1055 64.5C1055 62.5638 1056.56 61 1058.5 61Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.44 9.96289C1300.01 9.96289 1302.18 12.1388 1302.18 14.7104C1302.18 17.2819 1300.01 19.4578 1297.44 19.4578C1294.87 19.4578 1292.69 17.2819 1292.69 14.7104C1292.69 11.941 1294.67 9.96289 1297.44 9.96289Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.24 13.5215C1437.81 13.5215 1439.98 15.6974 1439.98 18.2689C1439.98 20.8404 1437.81 23.0162 1435.24 23.0162C1432.67 23.0162 1430.49 20.8404 1430.49 18.2689C1430.49 15.6974 1432.67 13.5215 1435.24 13.5215Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.5 125.902C1527.46 125.902 1530.03 128.276 1530.03 131.441C1530.03 134.408 1527.66 136.98 1524.5 136.98C1521.53 136.98 1518.96 134.606 1518.96 131.441C1519.16 128.276 1521.53 125.902 1524.5 125.902Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.53 329C1741.5 329 1744.07 331.374 1744.07 334.539C1744.07 337.506 1741.7 340.077 1738.53 340.077C1735.57 340.077 1733 337.704 1733 334.539C1733.2 331.374 1735.57 329 1738.53 329Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.27 22.4238C1038.65 22.4238 1040.62 24.4019 1040.62 26.7755C1040.62 29.1492 1038.65 31.1273 1036.27 31.1273C1033.9 31.1273 1031.92 29.1492 1031.92 26.7755C1031.92 24.4019 1033.9 22.4238 1036.27 22.4238Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.25 148.65C1411.21 148.65 1413.39 151.024 1413.39 153.793C1413.39 156.76 1411.02 158.936 1408.25 158.936C1405.28 158.936 1403.11 156.563 1403.11 153.793C1402.91 150.826 1405.28 148.65 1408.25 148.65Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.15 196C1362.12 196 1364.29 198.374 1364.29 201.143C1364.29 204.11 1361.92 206.286 1359.15 206.286C1356.19 206.286 1354.01 203.912 1354.01 201.143C1353.81 198.176 1356.19 196 1359.15 196Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.15 264C1471.12 264 1473.29 266.374 1473.29 269.143C1473.29 272.11 1470.92 274.286 1468.15 274.286C1465.19 274.286 1463.01 271.912 1463.01 269.143C1462.82 266.176 1465.19 264 1468.15 264Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1598.15 348C1601.12 348 1603.29 350.374 1603.29 353.143C1603.29 356.11 1600.92 358.286 1598.15 358.286C1595.19 358.286 1593.01 355.912 1593.01 353.143C1592.82 350.176 1595.19 348 1598.15 348Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1562.15 190C1565.12 190 1567.29 192.374 1567.29 195.143C1567.29 198.11 1564.92 200.286 1562.15 200.286C1559.19 200.286 1557.01 197.912 1557.01 195.143C1556.81 192.176 1559.19 190 1562.15 190Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.65 62.7773C1143.23 62.7773 1144.42 63.9642 1144.42 65.5467C1144.42 67.1291 1143.23 68.316 1141.65 68.316C1140.07 68.316 1138.88 67.1291 1138.88 65.5467C1139.08 63.9642 1140.27 62.7773 1141.65 62.7773Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.53 3.83008C1102.31 3.83008 1103.69 5.21465 1103.69 6.99487C1103.69 8.7751 1102.31 10.1597 1100.53 10.1597C1098.75 10.1597 1097.36 8.7751 1097.36 6.99487C1097.36 5.21465 1098.75 3.83008 1100.53 3.83008Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.163 46C967.942 46 969.326 47.3846 969.326 49.1648C969.326 50.945 967.942 52.3297 966.163 52.3297C964.383 52.3297 963 50.945 963 49.1648C963 47.3846 964.383 46 966.163 46Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.77 125.902C1366.73 125.902 1369.3 128.276 1369.3 131.441C1369.3 134.408 1366.93 136.979 1363.77 136.979C1360.8 136.979 1358.23 134.606 1358.23 131.441C1358.23 128.276 1360.8 125.902 1363.77 125.902Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.54 253C1317.5 253 1320.07 255.374 1320.07 258.539C1320.07 261.506 1317.7 264.077 1314.54 264.077C1311.57 264.077 1309 261.703 1309 258.539C1309 255.374 1311.57 253 1314.54 253Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.18 224.805C1611.15 224.805 1613.72 227.178 1613.72 230.343C1613.72 233.31 1611.35 235.882 1608.18 235.882C1605.22 235.882 1602.65 233.508 1602.65 230.343C1602.65 227.178 1605.22 224.805 1608.18 224.805Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.65 161.68C1177.24 161.68 1178.62 163.064 1178.62 164.647C1178.62 166.229 1177.24 167.614 1175.65 167.614C1174.07 167.614 1172.69 166.229 1172.69 164.647C1172.69 163.064 1174.07 161.68 1175.65 161.68Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.57 112.031C1167.74 112.031 1169.52 113.812 1169.52 115.987C1169.52 118.163 1167.74 119.944 1165.57 119.944C1163.39 119.944 1161.62 118.163 1161.62 115.987C1161.62 113.812 1163.39 112.031 1165.57 112.031Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.79 2.04883C1234.96 2.04883 1236.74 3.82909 1236.74 6.00497C1236.74 8.18085 1234.96 9.96112 1232.79 9.96112C1230.62 9.96112 1228.84 8.18085 1228.84 6.00497C1228.84 3.82909 1230.81 2.04883 1232.79 2.04883Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.55 3C1499.71 3 1502.08 5.57154 1502.08 8.53866C1502.08 11.7036 1499.51 14.0773 1496.55 14.0773C1493.38 14.0773 1491.01 11.5058 1491.01 8.53866C1490.81 5.57154 1493.38 3 1496.55 3Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.5 145L1847 125L1825 131.759L1841.5 145Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.2 81.3708L1918.02 64.3593L1893.71 60.7988L1903.2 81.3708Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.88 214L1818 193L1793 196.088L1807.88 214Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.69 173.089L1902.43 152.714L1871 145L1880.69 173.089Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742 235.297C1742 230.154 1746.15 226 1751.29 226C1756.43 226 1760.58 230.154 1760.58 235.297C1760.58 240.44 1756.43 244.594 1751.29 244.594C1746.15 244.792 1742 240.638 1742 235.297Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.15 147.9C1593.15 142.757 1597.3 138.604 1602.44 138.604C1607.58 138.604 1611.74 142.757 1611.74 147.9C1611.74 153.043 1607.58 157.197 1602.44 157.197C1597.3 157.395 1593.15 153.241 1593.15 147.9Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.07 25.5899C1725.07 20.4469 1729.22 16.293 1734.36 16.293C1739.5 16.293 1743.65 20.4469 1743.65 25.5899C1743.65 30.7328 1739.5 34.8867 1734.36 34.8867C1729.22 35.0845 1725.07 30.7328 1725.07 25.5899Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.61 29.5446C1901.61 26.5774 1903.98 24.0059 1907.15 24.0059C1910.11 24.0059 1912.68 26.3796 1912.68 29.5446C1912.68 32.5117 1910.31 35.0832 1907.15 35.0832C1903.98 35.0832 1901.61 32.5117 1901.61 29.5446Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1812.85 97.1955C1812.85 95.6131 1814.23 94.2285 1815.81 94.2285C1817.39 94.2285 1818.78 95.6131 1818.78 97.1955C1818.78 98.7778 1817.39 100.162 1815.81 100.162C1814.23 100.162 1812.85 98.7778 1812.85 97.1955Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.26 107.679C1708.26 104.91 1710.44 102.932 1713.01 102.932C1715.77 102.932 1717.75 105.108 1717.75 107.679C1717.75 110.448 1715.58 112.426 1713.01 112.426C1710.44 112.624 1708.26 110.448 1708.26 107.679Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.43 137.744C1762.43 135.371 1764.41 133.393 1766.78 133.393C1769.15 133.393 1771.13 135.371 1771.13 137.744C1771.13 140.118 1769.15 142.096 1766.78 142.096C1764.41 142.096 1762.43 140.118 1762.43 137.744Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.76 32.3142C1802.76 30.7317 1803.95 29.5449 1805.53 29.5449C1807.11 29.5449 1808.3 30.7317 1808.3 32.3142C1808.3 33.8966 1807.11 35.0834 1805.53 35.0834C1803.95 35.0834 1802.76 33.6988 1802.76 32.3142Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.2 39.0389C1645.2 36.8629 1646.97 34.8848 1649.35 34.8848C1651.52 34.8848 1653.5 36.6651 1653.5 39.0389C1653.5 41.2149 1651.72 43.1931 1649.35 43.1931C1647.17 43.1931 1645.2 41.4127 1645.2 39.0389Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493 348.154C1493 345.978 1494.78 344 1497.15 344C1499.33 344 1501.3 345.78 1501.3 348.154C1501.3 350.33 1499.52 352.308 1497.15 352.308C1494.98 352.308 1493 350.528 1493 348.154Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.9 153.965C1704.9 150.405 1707.87 147.437 1711.43 147.437C1714.99 147.437 1717.95 150.405 1717.95 153.965C1717.95 157.526 1714.99 160.493 1711.43 160.493C1707.87 160.295 1704.9 157.526 1704.9 153.965Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.85 73.4579C1743.85 71.6777 1745.23 70.293 1747.01 70.293C1748.79 70.293 1750.18 71.6777 1750.18 73.4579C1750.18 75.2382 1748.79 76.6229 1747.01 76.6229C1745.23 76.6229 1743.85 75.2382 1743.85 73.4579Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646 99.7583C1646 97.7802 1647.58 96 1649.76 96C1651.73 96 1653.51 97.5824 1653.51 99.7583C1653.51 101.736 1651.93 103.517 1649.76 103.517C1647.58 103.319 1646 101.736 1646 99.7583Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.61 190.363C1901.61 187.396 1903.99 184.824 1907.15 184.824C1910.12 184.824 1912.69 187.198 1912.69 190.363C1912.69 193.33 1910.31 195.901 1907.15 195.901C1903.99 195.901 1901.61 193.33 1901.61 190.363Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.61 -1.70871C1901.61 -3.29115 1903 -4.67578 1904.58 -4.67578C1906.16 -4.67578 1907.55 -3.29115 1907.55 -1.70871C1907.55 -0.126272 1906.16 1.25836 1904.58 1.25836C1903 1.25836 1901.61 -0.126272 1901.61 -1.70871Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.99 8.57727C1851.99 6.40137 1853.77 4.62109 1855.95 4.62109C1858.12 4.62109 1859.9 6.40137 1859.9 8.57727C1859.9 10.7532 1858.12 12.5334 1855.95 12.5334C1853.77 12.3356 1851.99 10.5554 1851.99 8.57727Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846.46 76.8216C1846.46 74.2501 1848.63 72.0742 1851.2 72.0742C1853.77 72.0742 1855.95 74.2501 1855.95 76.8216C1855.95 79.3931 1853.77 81.569 1851.2 81.569C1848.43 81.3712 1846.46 79.3931 1846.46 76.8216Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466 53.2969C1466 48.154 1470.15 44 1475.29 44C1480.43 44 1484.58 48.154 1484.58 53.2969C1484.58 58.4399 1480.43 62.5938 1475.29 62.5938C1470.15 62.7916 1466 58.4399 1466 53.2969Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371 312.297C1371 307.154 1375.15 303 1380.29 303C1385.43 303 1389.58 307.154 1389.58 312.297C1389.58 317.44 1385.43 321.594 1380.29 321.594C1375.15 321.792 1371 317.44 1371 312.297Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.66 77.6379L1259.62 63L1244 67.9452L1255.66 77.6379Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.59 67.1515L1589.55 52.5137L1573.93 57.4589L1585.59 67.1515Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.18 90.6624L1526.91 77.0137L1510.5 78.9917L1520.18 90.6624Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619.69 29.5446C1619.69 26.5774 1622.06 24.0059 1625.23 24.0059C1628.19 24.0059 1630.76 26.3796 1630.76 29.5446C1630.76 32.5117 1628.39 35.0832 1625.23 35.0832C1622.06 35.0832 1619.69 32.5117 1619.69 29.5446Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.84 32.3142C1520.84 30.7317 1522.03 29.5449 1523.61 29.5449C1525.19 29.5449 1526.38 30.7317 1526.38 32.3142C1526.38 33.8966 1525.19 35.0834 1523.61 35.0834C1522.03 35.0834 1520.84 33.6988 1520.84 32.3142Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686 17.5825C1686 16.5934 1686.79 16 1687.58 16C1688.57 16 1689.16 16.7912 1689.16 17.5825C1689.16 18.5715 1688.37 19.1649 1687.58 19.1649C1686.79 19.3627 1686 18.5715 1686 17.5825Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.43 187.395C1676.43 185.812 1677.82 184.428 1679.4 184.428C1680.98 184.428 1682.36 185.812 1682.36 187.395C1682.36 188.977 1680.98 190.362 1679.4 190.362C1677.82 190.362 1676.43 188.977 1676.43 187.395Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.89 26.0381C1356.89 23.8623 1358.67 22.082 1360.84 22.082C1363.02 22.082 1364.79 23.8623 1364.79 26.0381C1364.79 28.214 1363.02 29.9943 1360.84 29.9943C1358.67 29.9943 1356.89 28.214 1356.89 26.0381Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673 69.9671C1673 68.3846 1674.38 67 1675.96 67C1677.55 67 1678.93 68.3846 1678.93 69.9671C1678.93 71.5495 1677.55 72.9341 1675.96 72.9341C1674.38 72.9341 1673 71.5495 1673 69.9671Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.07 8.57727C1570.07 6.40137 1571.85 4.62109 1574.02 4.62109C1576.2 4.62109 1577.98 6.40137 1577.98 8.57727C1577.98 10.7532 1576.2 12.5334 1574.02 12.5334C1571.85 12.3356 1570.07 10.5554 1570.07 8.57727Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.13 283.682L1884.84 255L1854 264.693L1877.13 283.682Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.25 310.466L1808.3 283.564L1776.07 287.521L1795.25 310.466Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1873 357.998C1873 354.68 1875.68 352 1879 352C1882.32 352 1885 354.68 1885 357.998C1885 361.316 1882.32 363.996 1879 363.996C1875.68 364.123 1873 361.443 1873 357.998Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.53 565C1844.5 565 1847.07 567.374 1847.07 570.539C1847.07 573.506 1844.7 576.077 1841.53 576.077C1838.57 576.077 1836 573.703 1836 570.539C1836 567.374 1838.57 565 1841.53 565Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.54 409C1647.5 409 1650.07 411.374 1650.07 414.539C1650.07 417.506 1647.7 420.077 1644.54 420.077C1641.57 420.077 1639 417.703 1639 414.539C1639 411.374 1641.57 409 1644.54 409Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563 511.956C1563 509.78 1564.78 508 1566.95 508C1569.13 508 1570.91 509.78 1570.91 511.956C1570.91 514.132 1569.13 515.912 1566.95 515.912C1564.78 515.715 1563 513.934 1563 511.956Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575 294.956C1575 292.78 1576.78 291 1578.95 291C1581.13 291 1582.91 292.78 1582.91 294.956C1582.91 297.132 1581.13 298.912 1578.95 298.912C1576.78 298.715 1575 296.934 1575 294.956Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349 404.956C1349 402.78 1350.78 401 1352.95 401C1355.13 401 1356.91 402.78 1356.91 404.956C1356.91 407.132 1355.13 408.912 1352.95 408.912C1350.78 408.715 1349 406.934 1349 404.956Z",
    fill: "#C465DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1887 693.5C1887 692.125 1888.12 691 1889.5 691C1890.88 691 1892 692.125 1892 693.5C1892 694.875 1890.87 696 1889.5 696C1888.12 695.875 1887 694.75 1887 693.5Z",
    fill: "#FB896E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307 162.956C1307 160.78 1308.78 159 1310.95 159C1313.13 159 1314.91 160.78 1314.91 162.956C1314.91 165.132 1313.13 166.912 1310.95 166.912C1308.78 166.715 1307 164.934 1307 162.956Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744 428.956C1744 426.78 1745.78 425 1747.95 425C1750.13 425 1751.91 426.78 1751.91 428.956C1751.91 431.132 1750.13 432.912 1747.95 432.912C1745.78 432.715 1744 430.934 1744 428.956Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846 634.956C1846 632.78 1847.78 631 1849.95 631C1852.13 631 1853.91 632.78 1853.91 634.956C1853.91 637.132 1852.13 638.912 1849.95 638.912C1847.78 638.715 1846 636.934 1846 634.956Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694 286.956C1694 284.78 1695.78 283 1697.95 283C1700.13 283 1701.91 284.78 1701.91 286.956C1701.91 289.132 1700.13 290.912 1697.95 290.912C1695.78 290.715 1694 288.934 1694 286.956Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.15 420C1478.12 420 1480.29 422.374 1480.29 425.143C1480.29 428.11 1477.92 430.286 1475.15 430.286C1472.19 430.286 1470.01 427.912 1470.01 425.143C1469.81 422.176 1472.19 420 1475.15 420Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 489.352C1680 486.978 1681.98 485 1684.35 485C1686.72 485 1688.7 486.978 1688.7 489.352C1688.7 491.725 1686.72 493.704 1684.35 493.704C1681.98 493.704 1680 491.725 1680 489.352Z",
    fill: "#F9C977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.4 506L1866 490.042L1842 484L1849.4 506Z",
    fill: "#50E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5347 168C84.5002 168 87.0703 170.374 87.0703 173.539C87.0703 176.506 84.6979 179.077 81.5347 179.077C78.5692 179.077 75.9991 176.703 75.9991 173.539C75.9991 170.374 78.5692 168 81.5347 168Z",
    fill: "#C465DB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnfettiDesktop);
export default __webpack_public_path__ + "static/media/сonfetti-desktop.64f4e4e6de3a0e8f5887ae1ae289d59f.svg";
export { ForwardRef as ReactComponent };